import { FeatureFlag } from '@feature-flag-lib/feature-flags.model'

export const createFeatureFlag = <TValue>(
    name: string,
    defaultValue: TValue
): FeatureFlag<TValue> => ({
    defaultValue,
    name,
})
